{
  "#ESL_LINK": {
    "TITLE": "ESL",
    "ESL_CODE": {
      "MANUAL_INPUT": "Manuelle Eingabe",
      "PLACEHOLDER": "ESL Code",
      "SUBMIT": "Bestätigen",
      "OR": "Oder",
      "SCAN_HEADER": "ESL scannen",
      "SCAN_DESCRIPTION": "ESL mithilfe des integrierten Scanners suchen"
    },
    "ASSOCIATE_ITEMS": {
      "TITLE": "ESL Zuordnen",
      "MANUAL_INPUT": "Manuelle Eingabe",
      "PLACEHOLDER": "Artikelnummer",
      "OR": "Oder",
      "SCAN_HEADER": "Artikel scannen",
      "SCAN_DESCRIPTION": "Artikel mithilfe des integrierten Scanners suchen",
      "SUBMIT": "Speichern",
      "ESL": "ESL-Code",
      "ITEMS": "Artikel",
      "ADD": "Hinzufügen",
      "SUCCESS": "Der Artikel wurde dem ESL zugeordnet",
      "NO_ITEMS": "Es wurden noch keine Artikel hinzugefügt"
    },
    "ASSOCIATE": {
      "TITLE": "ESL Zuordnen"
    },
    "DISSOCIATE": {
      "TITLE": "ESL Trennen",
      "SCAN": "Scannen",
      "ESL": "ESL-Code",
      "SUBMIT": "Zuordnung trennen",
      "SUCCESS": "Die Zuordnung von {{esl}} wurde aufgelöst"
    },
    "DIALOGS": {
      "ITEM": {
        "TITLE": "Artikel auswählen",
        "ITEM": "Artikel",
        "SUBMIT": "Auswählen"
      }
    }
  },
  "#ESL_LINK_STORAGE": {
    "TITLE": "ESL Lager"
  }
}
